import styled from 'styled-components';

export const TitleContainer = styled.h1`
  color: #c7c0c0;
  font-size: 5rem;
  z-index: 5;
`;